import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.305,
	height: 22.02,
	viewBox: "0 0 18.305 22.02",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "doc-icon",
		transform: "translate(-229 -431)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "icon-back",
			transform: "translate(229 431)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "back-shape",
					d: "M31.276,1.685H21.5a1.282,1.282,0,0,0-1.282,1.282V22.423A1.282,1.282,0,0,0,21.5,23.7H35.41a1.282,1.282,0,0,0,1.282-1.282V7.1Z",
					transform: "translate(-18.387 -1.685)",
					fill: "#f7f6f8"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner-shadow",
					d: "M160.554,61.4h3.74v3.74Z",
					transform: "translate(-145.99 -55.98)",
					fill: "#eae9ec"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner",
					d: "M142.07,1.685V5.82a1.3,1.3,0,0,0,1.3,1.282h4.117Z",
					transform: "translate(-129.182 -1.685)",
					fill: "#d7d6db"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "block_shadow",
					"data-name": "block shadow",
					d: "M34.917,129.774v-7.125a.58.58,0,0,0-.58-.58H20.221v8.285H34.337a.58.58,0,0,0,.58-.58",
					transform: "translate(-18.387 -111.149)",
					fill: "#dee2e6"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "color_block",
					"data-name": "color block",
					d: "M15.95,125.635H.58a.649.649,0,0,1-.58-.7v-8.6a.649.649,0,0,1,.58-.7H15.95a.649.649,0,0,1,.58.7v8.6a.649.649,0,0,1-.58.7",
					transform: "translate(0 -107.299)",
					fill: "#3258b5"
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_3132",
			"data-name": "Path 3132",
			d: "M-6.433,0h1.582c1.645,0,2.289-.721,2.289-2.576s-.644-2.576-2.289-2.576H-6.433c-.2,0-.28.084-.28.287V-.287C-6.713-.084-6.629,0-6.433,0Zm.9-1.071v-3.01h.693c.784,0,1.043.371,1.043,1.5s-.259,1.5-1.043,1.5ZM.413.077C1.96.077,2.6-.707,2.6-2.576S1.96-5.229.413-5.229s-2.191.784-2.191,2.653S-1.127.077.413.077ZM.413-1C-.3-1-.546-1.4-.546-2.576s.252-1.575.959-1.575.959.4.959,1.575S1.127-1,.413-1ZM5.565.077A3.128,3.128,0,0,0,6.622-.091c.2-.063.28-.154.28-.329v-.595c0-.2-.126-.252-.343-.182a2.912,2.912,0,0,1-.889.161c-.784,0-1.05-.4-1.05-1.54s.266-1.54,1.05-1.54a2.344,2.344,0,0,1,.805.175c.21.077.315.028.357-.161l.126-.539a.293.293,0,0,0-.217-.378,3.154,3.154,0,0,0-1.176-.21c-1.456,0-2.177.721-2.177,2.653S4.109.077,5.565.077Z",
			transform: "translate(237.18 446.929)",
			fill: "#fff"
		})]
	})
});
export default SvgDocIcon;
